import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemThumbnailComponent } from '../../components/item-thumbnail/item-thumbnail.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import ImageService from '../../services/image.service';
import ProfilePictureService from '../../services/profile-picture.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'card-profile',
	templateUrl: './card-profile.component.html',
	imports: [ CommonModule, TranslatePipe, ItemThumbnailComponent, LoaderOverlayComponent, FormsModule ]
})
export class CardProfileComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private imageService: ImageService = inject(ImageService);
	private profilePictureService: ProfilePictureService = inject(ProfilePictureService);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		this.vm.img = this.profilePictureService.getCoverPictureUrl(this.vm.user);
		this.vm.uid = 'cpf-' + Date.now();
		this.vm.title = this.getTitle();
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, this.config.getBroadcastConfig().Session.UPDATE, () => {
					this.vm.user = this.session.getSession().user;
					this.vm.title = this.getTitle();
				})
		);
		
		this.vm.upload = this.upload;
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		this.upload(input.files);
	}
	
	upload(files) {
		if (!files || !files.length) return;
		
		this.vm.loaderTimeout = this.angularHelperService.createTimer(
			() => { this.vm.processing = true; },
			this.config.getOtherConfig().LOADER_TIMEOUT_INIT
		);
		this.imageService.uploadImage({ file: files[0] }, 'cover', (img) => {
			this.session.updateCoverPicture(img);
			this.vm.img = this.profilePictureService.getCoverPictureUrl(this.vm.user);
			this.clearLoader();
		}, (err) => {
			this.clearLoader();
		});
	}
	
	clearLoader() {
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) this.angularHelperService.createTimer(
			() => { this.vm.processing = false; },
			this.config.getOtherConfig().LOADER_TIMEOUT_DELAY
		);
	}
	
	getTitle() {
		if (!this.vm.user || !this.vm.user.businessUserType) return;
		switch (this.vm.user.businessUserType) {
			case 'BUSINESS_CLIENT':
			case 'SERVICE_OWNER':
				return this.vm.user.businessName;
			default:
				var title: any = this.vm.user.firstname + ' ' + this.vm.user.lastname;
				if (this.vm.user.parentBusinessUser && this.vm.user.parentBusinessUser.businessName) {
					title += ' (' + this.vm.user.parentBusinessUser.businessName + ')';
				}
				return title;
		}
	}
	
}